import React, {createContext, useState} from "react";
import PMSPatientPrescriptionServices from "../../services/pms_services/PMSPatientPrescriptionServices";
import Notification from "../../components/common/Notification";

export const PMSPatientPrescriptionContext = createContext("PMSPatientPrescriptionContext");

const PMSPatientPrescriptionContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [totalElements, setTotalElements] = useState(0);
    const [prescriptions, setPrescriptions] = useState([]);
    const [prescription, setPrescription] = useState(null);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAllPrescriptionsByPatientId = async (patientId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSPatientPrescriptionServices.getAllPrescriptionsByPatientId(patientId, params);
            setPrescriptions(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getPrescriptionById = async (patientId, id) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSPatientPrescriptionServices.getPrescriptionById(patientId, id);
            setPrescription(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const createPrescription = async (patientId, data) => {
        try {
            setLoading(true);
            await PMSPatientPrescriptionServices.createPrescription(patientId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription created successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updatePrescriptionById = async (id, data) => {
        try {
            setLoading(true);
            await PMSPatientPrescriptionServices.updatePrescriptionById(id, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const deletePrescriptionById = async (id) => {
        try {
            setLoading(true);
            await PMSPatientPrescriptionServices.deletePrescriptionById(id);
            setLoading(false);
            Notification("success", "SUCCESS", "Prescription deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSPatientPrescriptionContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                prescriptions,
                prescription,
                getAllPrescriptionsByPatientId,
                getPrescriptionById,
                createPrescription,
                updatePrescriptionById,
                deletePrescriptionById,
            }}
        >
            {children}
        </PMSPatientPrescriptionContext.Provider>
    );
};

export default PMSPatientPrescriptionContextProvider;
